import { Component, OnInit, Inject, OnDestroy, Input, AfterViewInit } from "@angular/core";
import { OrderRecapPromiseService, TraderGroupPromiseLookupService } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CoreQuote } from "shared/cubiq-services";
import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";
import { ElementRef, ViewChild } from "@angular/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { TranslateService } from "@ngx-translate/core";
import { BFXDomHelper } from "app/bfx-common/helpers/bfx-dom-helper";
import { BfxClipboardService } from "shared/helper-services/bfx-clipboard.service";

@Component({
  selector: `bfx-order-recap`,
  templateUrl: "./html/bfx-order-recap.html",
  standalone: false,
})
export class BfxOrderRecapComponent implements OnInit, GoldenLayoutComponent, AfterViewInit {
  public selectedIds: any;

  public stringToCopy: string = "";

  public recapResults: Array<string> | string = [];

  public parentPopup: GoldenLayoutPopout;

  public stringToDisplay: string = "";

  public viewInitComplete: boolean = false;
  public recapError: boolean = false;
  public recapInfo: boolean = false;

  constructor(
    public orderRecapService: OrderRecapPromiseService,
    private _clipboardService: BfxClipboardService,
    private translationService: TranslateService,
  ) {}

  public control: any = {
    mode: true,
    containerHeight: 324,
    // perfect scrollbar configuration
    scrollbarConfig: {
      suppressScrollX: true,
      minScrollbarLength: 40,
    },
  };

  public config: any = {
    debug: false,
  };

  ngOnInit(): void {
    this.control.scrollbarConfig.minScrollbarLength = BFXDomHelper.getVariablePx(
      document,
      "ds-comp-scrollbar-handle-container-sizing-height",
      40,
    );

    if (this.selectedIds) {
      this.recapInfo = true;
      this.stringToDisplay = "Loading ...";
      this.orderRecapService.getOrderRecap(this.selectedIds).then(
        (recap: Array<string>) => {
          if (Array.isArray(recap) == false || recap.length == 0) {
            this.stringToDisplay = "no recap records found";
            return;
          }
          this.recapInfo = false;
          this.recapError = false;
          this.stringToDisplay = "";
          recap.forEach((record) => {
            this.stringToCopy += record;
          });

          this.recapResults = recap.filter((item) => {
            return item.replace(/(\r?\n|\r)/gm, "");
          });
        },
        (error: any) => {
          this.recapInfo = false;
          this.recapError = true;
          this.stringToDisplay = "";

          try {
            if (error == null || Array.isArray(error.errorMessages) == false) {
              this.stringToDisplay = "Recap request failed with unknown error";
              return;
            }
            error.errorMessages.forEach((element) => {
              let msg = JSON.parse(element);
              this.stringToDisplay += this.translationService.instant(msg.id, msg.args);
            });
          } catch (e) {
            this.stringToDisplay = "Recap request failed with unknown error";
          }
        },
      );
    }
  }

  ngAfterViewInit() {
    this.viewInitComplete = true;
  }

  // Golden layout popout callbacks
  glInit(data: any, container: any, state: any): void {
    this.selectedIds = data;
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
  }

  close() {
    this.parentPopup.close();
  }

  resize(event: any): void {}

  resizeDocked(event: any) {}

  public actionExport_copyToClipboard(): void {
    try {
      this._clipboardService.setContent(this.stringToCopy).then(() => {
        if (!this._clipboardService.copyContent()) {
          logger.out.error(
            "ERROR: BfxOrderRecapComponent.actionExport_copyToClipboard(): Copy to clipboard operation failed!",
          );
        }
      });
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxOrderRecapComponent.actionExport_copyToClipboard(): Exception: ",
        ex,
      );
    }
  }
}
